import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { translations } from "../../utils/translations.js";
import { useSelector } from "react-redux";

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (min-width: 600px) {
    flex-direction: column;
    height: 100%;
  }
`;
const Item = styled(NavLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 1rem;
  color: var(--white);
  padding: 0.5rem 2rem;
  cursor: pointer;
  position: relative;

  &:hover,
  &.active {
    text-shadow: 0px 0px 1px currentColor;
    background-color: var(--background-green);
  }

  @media (max-width: 600px) {
    border-right: 1px solid var(--white-gray-color);
    margin-bottom: 1rem;
    padding: 0.3rem 1rem;
  }
`;

const SupportLayout = ({ children }) => {
  const languageCode = useSelector((state) => state.settings.languageCode);
  return (
    <Wrapper data-testid="support-layout">
      <SidebarWrapper>
        <Item to="/retur">
          {translations[languageCode]["footer-retur-section"]}
        </Item>
        <Item to="/transport-payment">
          {translations[languageCode]["footer-pay-section"]}
        </Item>
        <Item to="/terms">
          {translations[languageCode]["footer-terms-section"]}
        </Item>
        <Item to="/support">Contact</Item>
      </SidebarWrapper>
      {children}
    </Wrapper>
  );
};

export default SupportLayout;
